module.exports = __webpack_public_path__ + "img/EHIS.6ddd8537.png";